import React from "react";
import Modal from "../../../containers/Modal";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
import DynamicInput, {Label} from "../../../components/forms/DynamicInput";
import parse from "html-react-parser";
// import {simpleDate} from "../../../hooks/helpers";
// import {ReactComponent as CancelIcon} from "../../../assets/icons/cancel.svg";

export default function ShowCourseModal({isOpen, close, theme, data, type, title}) {
   if (!data) return null;
   return (
      <Modal
         isOpen={isOpen}
         close={() => {
            close();
         }}
         // confirm={true}
         size="big"
         theme={theme}
         title={title}
      >
         <DivModal>
            <div>{type === "info" && <TypeInfo data={data} />}</div>
         </DivModal>
      </Modal>
   );
}

const TypeInfo = ({data}) => {
   return (
      <>
         <Grid>
            <Col large={4}>
               <Label className="textModal">Nombre:</Label>
               <DynamicInput className="readGhost" value={data.name} readOnly={true} placeholder="Nombre" name="name" />
            </Col>
            <Col large={8}>
               <Grid>
                  <Col large={3}>
                     <Label className="textModal">Total de horas:</Label>
                     <DynamicInput
                        className="readGhost"
                        value={data.endDate + " horas" || "12 horas"}
                        readOnly={true}
                        placeholder="Nombre"
                        name="name"
                     />
                  </Col>
                  <Col large={1}></Col>
                  <Col large={3}>
                     <Label className="textModal">Código de curso:</Label>
                     <DynamicInput
                        className="readGhost"
                        value={data.startDate || "LaK28"}
                        readOnly={true}
                        placeholder="Nombre"
                        name="name"
                     />
                  </Col>
                  <Col large={3}>
                     <Label className="textModal">Inicio de curso:</Label>
                     <DynamicInput className="readGhost" value={data.date || "LaK28"} readOnly={true} placeholder="Nombre" name="name" />
                  </Col>
               </Grid>
            </Col>
         </Grid>
         <Grid className="maxMargin">
            <Col large={4}>
               <Grid>
                  <Col large={6}>
                     <Label className="textModal">PERFIL DE EGRESADO:</Label>
                     <Label as="div" className="readGhost">
                        {data.graduateProfile}
                     </Label>
                  </Col>
               </Grid>
            </Col>
            <Col large={8}>
               <Grid>
                  <Label className="textModal">Descripción corta:</Label>
                  <Label as="div" className="readGhost">
                     {data.shortDescription}
                  </Label>
               </Grid>
            </Col>
         </Grid>
         <Grid className="maxMargin">
            <Col large={4}>
               <Grid>
                  <Col large={12}>
                     <Label className="textModal">Facilitadores:</Label>
                     <Grid>
                        <Col large={12}>
                           <DynamicInput
                              className="readGhost"
                              value={data.facilitator || "Nombre facilitador"}
                              readOnly={true}
                              placeholder="Nombre"
                              name="name"
                           />
                        </Col>
                        <Col large={12}>
                           <DynamicInput
                              className="readGhost"
                              value={data.facilitator || "Nombre facilitador"}
                              readOnly={true}
                              placeholder="Nombre"
                              name="name"
                           />
                        </Col>
                     </Grid>
                  </Col>
               </Grid>
            </Col>
            <Col large={8}>
               <Grid>
                  <Label className="textModal">DESCRIPCIÓN LARGA:</Label>
                  <Label as="div" className="readGhost">
                     {parse(data.longDescription)}
                  </Label>
               </Grid>
            </Col>
         </Grid>
         <Grid className="maxMargin">
            <Col large={7}>
               <Grid>
                  <Col large={12}>
                     <Label className="textModal">Imagen:</Label>
                     <DynamicInput
                        className="readGhost"
                        value={data.date || "imganeEjemplo.jpg"}
                        readOnly={true}
                        placeholder="Nombre"
                        name="name"
                     />
                  </Col>
               </Grid>
            </Col>
            <Col large={5}></Col>
         </Grid>
      </>
   );
};
/* 


                  <Col large={12}>
                     <Label className="textModal">Imágen:</Label>
                     <DynamicInput className="readGhost" value={data.date || "imagenEjemplo.jpg"} readOnly={true} placeholder="Nombre" name="name" />
                  </Col>
*/
const DivModal = styled.div`
   .buttonModal {
      margin-top: 2em;
   }
   .maxMargin {
      margin-top: 2em;
   }
   .textModal {
      margin-bottom: 0.5em;
   }
`;
